(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    const openShopPayPlans = (panel) => {
    const paymentTerms = panel.querySelector('shopify-payment-terms');
    const plansButton = paymentTerms?.shadowRoot?.querySelector('button[aria-label="View sample plans"]');
    plansButton?.click();
  };

  document.addEventListener('click', (event) => {
    const panel = event.target.closest?.('.shop-pay-highlight');
    if (!panel) return;

    const clickedControl = event.composedPath().some((element) => {
      return element instanceof Element && element.matches('button, a');
    });

    if (clickedControl) return;
    openShopPayPlans(panel);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const panel = event.target.closest?.('.shop-pay-highlight');
    if (!panel || event.target !== panel) return;

    event.preventDefault();
    openShopPayPlans(panel);
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const depositCheckbox = form?.querySelector?.('[data-mighte-deposit-required]');
    if (!depositCheckbox) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!depositCheckbox.checked) {
      depositCheckbox.setCustomValidity('The refundable deposit is required with this rental.');
      depositCheckbox.reportValidity();
      return;
    }
    depositCheckbox.setCustomValidity('');

    const variantField = form.querySelector('[name="id"]');
    const quantityField = form.querySelector('[name="quantity"]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const rentalVariantId = Number(variantField?.value);
    const depositVariantId = Number(depositCheckbox.dataset.depositVariantId);
    const quantity = Math.max(1, Number(quantityField?.value || 1));

    if (!rentalVariantId || !depositVariantId) return;

    if (addButton) addButton.disabled = true;

    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            { id: rentalVariantId, quantity: quantity },
            { id: depositVariantId, quantity: 1 }
          ]
        })
      });

      if (!response.ok) throw new Error('Unable to add the rental package to the cart.');
      window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
    } catch (error) {
      if (addButton) addButton.disabled = false;
      window.alert(error.message || 'Unable to add the rental package to the cart. Please try again.');
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
